import { effect, inject, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { StorageService } from '@td/core';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class LangService {
  private static readonly DEFAULT_LANGUAGE = 'en';
  private static readonly LANGUAGE_KEY = 'locale';

  private readonly translocoService = inject(TranslocoService);
  private readonly storage = inject(StorageService);

  readonly language = signal(this.storage.getItem(LangService.LANGUAGE_KEY, LangService.DEFAULT_LANGUAGE));
  readonly languages = signal([
    { value: 'en', viewValue: 'language-selector.en' },
    { value: 'es', viewValue: 'language-selector.es' },
  ]);
  readonly lang$ = toObservable(this.language);

  constructor() {
    effect(() => {
      this.storage.setItem(LangService.LANGUAGE_KEY, this.language());
      this.translocoService.setActiveLang(this.language());
      document.documentElement.setAttribute('lang', this.language());
    });
  }
}
